import { type NodeTypes } from '@xyflow/react';

import { EDataType, NodeDataType } from '../models/node-data';
import GroupNode from './group-node';
import ImageNode from './image-node';
import NoteNode from './note-node';
import ProjectFrameNode from './project-frame-node';
import StandardNode from './standard-node';

const nodeTypes: NodeTypes = Object.values(NodeDataType).reduce((acc, type) => {
  acc[type as NodeDataType] = StandardNode;
  return acc;
}, {} as NodeTypes);

// Add more node types here
nodeTypes[EDataType.Group] = GroupNode;
nodeTypes[EDataType.Note] = NoteNode;
nodeTypes[EDataType.Image] = ImageNode;
nodeTypes[EDataType.ProjectFrame] = ProjectFrameNode;
export default nodeTypes;
